// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

function updateVariantDisplay(selectedVariantId) {
    const variants = document.querySelectorAll('[data-variant-id]');

    variants.forEach(variant => {
        const variantId = variant.getAttribute('data-variant-id');

        if (variantId === selectedVariantId) {
            variant.style.display = 'block'; // Show the matching variant
        } else {
            variant.style.display = 'none';  // Hide all others
        }
    });
}

// Run when the page loads
document.addEventListener("DOMContentLoaded", function () {
    const currentVariantElement = document.querySelector('[name="id"]'); // Default Shopify variant input
    if (currentVariantElement) {
        const selectedVariantId = currentVariantElement.value;
        updateVariantDisplay(selectedVariantId);
    }
});

// Run when the variant changes
document.addEventListener("product:variant-change", function (evt) {
    console.log("Product variant changed");
    console.log(evt.detail.variant);
    console.log(evt.detail.variant.id);

    const selectedVariantId = String(evt.detail.variant.id); // Ensure it's a string for comparison
    updateVariantDisplay(selectedVariantId);
});

// custom GA select_item
// document.addEventListener("product:variant-change", function (evt) {
//   let prdtitle = document.querySelector('.product__title').innerHTML.trim();
//   dlPush({
//     event: 'select_item',
//     ecommerce: { items: [{
//       item_id: evt.detail.variant.id,
//       item_name: prdtitle,
//       item_variant: evt.detail.variant.title,
//       price: evt.detail.variant.price / 100,
//       quantity: 1
//     }] }
//   });
// });

// custom GA add_to_cart
document.addEventListener("cart:item-added", function (evt) {
  dlPush({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      value: Number(evt.detail.product.price) / 100,
      items: [{
        item_id: evt.detail.product.variant_id,
        item_name: evt.detail.product.product_title,
        item_variant: evt.detail.product.variant_title,
        price: Number(evt.detail.product.price) / 100,
        quantity: Number(evt.detail.product.quantity)
      }]
    }
  });
});

// custom GA remove_from_cart
document.addEventListener("cart:updated", function (evt) {
  if (evt.detail.cart.items_removed !== undefined && evt.detail.cart.items_removed.length > 0) {
    dlPush({
      event: 'remove_from_cart',
      ecommerce: {
        currency: 'EUR',
        value: Number(evt.detail.cart.items_removed[0].price),
        items: [{
          item_id: evt.detail.cart.items_removed[0].variant_id,
          item_name: evt.detail.cart.items_removed[0].product_title,
          item_variant: evt.detail.cart.items_removed[0].variant_title,
          price: Number(evt.detail.cart.items_removed[0].price),
          quantity: Number(evt.detail.cart.items_removed[0].quantity)
        }]
      }
    });
  }
});


// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
